import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  assignTag(request: Boundaries["assignTag"]["request"]): void;
}

function useAssignTag(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isAssignTagRequestPending),
    isRequestSuccess: useSelector(selector.isAssignTagRequestSuccess),
    isRequestFailure: useSelector(selector.isAssignTagRequestFailure),
    assignTag: core.assignTag,
  };
}

export { useAssignTag };
